import type { ServiceForSelectedServiceType } from '@common/interfaces/processStartWizard';
import { ServiceCode } from '@common/enums';
import { never } from '@common/utils/never';
import type { IServiceDataItem } from './getServiceData';

export function getServiceDataForEpisodeSomnology(
    service: ServiceForSelectedServiceType,
    serviceCode: ServiceCode.OSASV | ServiceCode.OSAS
): Partial<IServiceDataItem> {
    switch (serviceCode) {
        case ServiceCode.OSASV:
        case ServiceCode.OSAS:
            return {
                costs: 'eigen risico belast',
                steps: [
                    serviceCode === ServiceCode.OSASV
                        ? 'Voer anamnese en lichamelijk onderzoek uit'
                        : 'Verstuur een digitale verwijzing naar Ksyos',
                    'Patiënt ontvangt slaaprecorder thuis',
                    'Patiënt heeft videoconsult met Ksyos specialist',
                    'Je ontvangt de uitslag via Edifact (in je HIS)',
                    'Eventuele behandeling/begeleiding doet Ksyos',
                ],
                subTitle: (
                    <>
                        Voor patiënten bij wie je <strong>slaapapneu</strong> vermoedt
                    </>
                ),
                title: 'Slaapapneu verwijzing',
                waitingTime: 'medisch consult volgt binnen 2 weken na slaaponderzoek',
            };

        default:
            never(serviceCode);
    }
}
